import { render, staticRenderFns } from "./CategoryAutoChat.vue?vue&type=template&id=e56a65e6"
import script from "./CategoryAutoChat.vue?vue&type=script&lang=js"
export * from "./CategoryAutoChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports